<template>
  <div style="margin-top: 10px">
    <div v-for="(item,index) in items" class="row" :key="index">
      <div class="col-md-12">
        <label>{{item.label}}</label>
        <div
          v-if="item.visualElementType=='TEXT_FIELD'||item.visualElementType== 'HIDDEN_TEXT_FIELD'"
        >
          <vue-numeric
            currency="$"
            v-bind:precision="2"
            @blur="change"
            decimal-separator="."
            thousand-separator=" "
            v-model="item.valor"
            class="form-control"
            v-if="item.type=='IMP'"
            :type="item.typeText"
          ></vue-numeric>
          <base-input v-if="item.type=='CBA'" v-model="item.valor" :type="item.typeText"></base-input>
          <base-input v-if="item.type=='ALF'" v-model="item.valor" :type="item.typeText"></base-input>
          <KitsDateTime v-if="item.type=='FEC'" v-model="item.valor" />
          <input
            type="checkbox"
            id="human"
            name="human"
            v-model="item.valor"
            v-if="item.type=='LOG'"
          />
        </div>
        <div v-if="item.visualElementType=='COMBO_BOX_ESTATICO'">
          <RapiPagoCombo v-bind:item="item.ValuesList" v-bind:selectedvalue.sync="item.valor"></RapiPagoCombo>
        </div>
        <div v-if="item.visualElementType=='CHECKBOX'">
          <input type="checkbox" id="human" name="human" v-model="item.valor" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { truncate } from "fs";
import KitsCombo from "@/components/KitsCombo";
import KitsDate from "@/components/KitsDate";
import KitsDateTime from "@/components/KitsDateTime";
import RapiPagoCombo from "@/components/Specific/Combos/RapiPagoCombo";

export default {
  name: "RapiPagoManualControl",
  components: { KitsCombo, KitsDateTime, KitsDate, RapiPagoCombo },
  props: {
    items: Array
  },
  data() {
    return {
    };
  },
  methods: {
    change(element) {
      this.$emit("input", this.model);
    },
    boton() {
      console.log(this.items);
    }
  },
};
</script>